/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import StoreLeftMenu from '../../menu/StoreLeftMenu';
import Footer from '../../components/Footer';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

//import $ from 'jquery';
//import '../../slick.js'
import Slider from 'react-slick';

import OriginalComment from './OriginalComment';
import OriginalGoodsEtcList from './OriginalGoodsEtcList';
import queryString from 'query-string';
// import $ from "jquery";

class StoreOriginalGoods extends PureComponent {
  state = {
    slideIndex: 0,
    slidePlay: true,
    ichSerial: 0,
    toggle: false,
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    const { location } = this.props;
    const query = queryString.parse(location.search);
    let i = query.i;

    //console.log(i)
    //if(i === '' || i === undefined || i === null) {
    //    i = 0
    //}

    this._getData(i);

    setTimeout(() => {
      //this._onGoto(i)
    }, 800);
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  _getData = async (ichSerial) => {
    // const { pageSize } = this.state;
    // const { match, location } = this.props;
    const result = await this._getApi(1, 100);
    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const originalList = result.data[0].listData;
    let i;
    if (intReturn === 0) {
      if (con > 0) {
        if (this._isLoad) {
          if (
            ichSerial === '' ||
            ichSerial === undefined ||
            ichSerial === null
          ) {
            i = 0;
          } else {
            //i = colSerial
            i = originalList.findIndex((item, index) => {
              //console.log(item.colSerial, colSerial)
              return parseInt(item.ichSerial) === parseInt(ichSerial);
            });
          }

          this.setState({
            originalList: originalList,
            gotoPage: 1,
            con: con,
            pageCount: pageCount,
            ichSerial: originalList[0].ichSerial,
          });
          //console.log(originalList[0].ichSerial)
          setTimeout(() => {
            this._onGoto(i);
            this._getTop(originalList[0].ichSerial);
          }, 600);
        }
      }
    }
  };

  _getApi = (gotoPage, pageSize) => {
    const { apiUrl } = this.props;

    return axios(
      apiUrl +
        '/getOriginalGoods?gotoPage=' +
        gotoPage +
        '&pageSize=' +
        pageSize
    )
      .then((response) => response)
      .catch((error) => {
        alert(
          '네트워크 오류: 오리지널 굿즈 데이터를 로드 하는 중 오류가 발생했습니다.'
        );
      });
  };
  _getTop = async (ichSerial) => {
    const result = await this._getTopApi(ichSerial);
    const intReturn = result.data[0].intReturn;
    const topInfo = result.data[0].listData;
    //console.log(topInfo)
    //console.log(intReturn)
    //console.log(ichSerial)
    if (intReturn === 0) {
      if (this._isLoad) {
        this.setState({
          topInfo,
          contentIdx: topInfo[0].contentIdx,
          ichSerial,
        });
        this._getGoods(ichSerial);
      }
    }
  };
  _getTopApi = (ichSerial) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/storeOriginalTop', {
        params: {
          idx: ichSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  //관련 상품.

  _getGoods = async (serial) => {
    const result = await this._getGoodsApi(serial);
    const intReturn = result.data[0].intReturn;
    const goodList = result.data[0].listData;
    //console.log(intReturn)
    //console.log(goodList)
    if (this._isLoad) {
      if (intReturn === 0) {
        this.setState({
          goodList,
        });
      } else {
        this.setState({
          goodList: [],
        });
      }
    }
  };
  _getGoodsApi = (serial) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/storeOriginalGoodsListNew', {
        params: {
          serial: serial,
          goodsType: 'O',
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };

  /*
    _getGoods = async (contentIdx) => {
        const result = await this._getGoodsApi(contentIdx)
        const intReturn = result.data[0].intReturn;
        const goodList = result.data[0].listData;
        //console.log(intReturn)
        //console.log(goodList)
        if(intReturn === 0) {
            this.setState({
                goodList,
                contentIdx
            })
        }
    }
    _getGoodsApi = (contentIdx) => {
        const { apiUrl } = this.props;
        return axios.post(apiUrl + '/storeOriginalGoodsList', {
            params: {
                contentIdx: contentIdx
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })
    }
    */
  _renderItem = () => {
    const { originalList } = this.state;

    const list = originalList.map((item, index) => {
      return (
        <div
          className="store_orgin_item"
          key={index}
          onClick={() => this._onGoto(index)}
        >
          {/* 오리지널 굿즈 */}
          <div className="orgin_goods">
            {index <= 1 ? <div className="ico_new">new</div> : null}
            <div className="thumb">
              <img src={item.listImg} alt="" />
            </div>
            <div className="subject">
              <a
                style={{ cursor: 'pointer' }}
                onClick={() => this._onGoto(index)}
              >
                {item.title}
              </a>
            </div>
          </div>
        </div>
      );
    });

    return list;
  };
  _online = (goodSerial, SaleActive) => {
    if (SaleActive) {
      window.open('https://shop.aniplustv.com/Item/' + goodSerial, '', '');
    } else {
      toast.warn('오프라인에서만 구매가 가능한 굿즈입니다.');
    }
  };
  _renderGoodItem = () => {
    const { goodList } = this.state;
    const { imgUrl } = this.props;
    const con = goodList.length;
    const list = goodList.map((item, index) => {
      return (
        <div
          key={index}
          className="img_orgin_item"
          style={{
            width: item.imgType === 'W' || item.imgType === 'X' ? '100%' : null,
          }}
          index={index}
          con={con}
        >
          <div
            className={
              item.imgType === 'W' || item.imgType === 'X'
                ? 'inven_status_wide'
                : 'inven_status'
            }
            style={{ bottom: item.imgType === 'X' ? 5 : null }}
          >
            <dl>
              {/*<dt>서울</dt>*/}
              <dd>
                {item.h_stock <= 0 ? (
                  <img src={imgUrl + '/img/store/h_no.png'} />
                ) : item.h_stock >= 10 ? (
                  <img src={imgUrl + '/img/store/h_full.png'} />
                ) : (
                  <img src={imgUrl + '/img/store/h_soon.png'} />
                )}
              </dd>
            </dl>
            <dl>
              {/*<dt>대전</dt>*/}
              <dd>
                {item.d_stock <= 0 ? (
                  <img src={imgUrl + '/img/store/d_no.png'} />
                ) : item.d_stock >= 10 ? (
                  <img src={imgUrl + '/img/store/d_full.png'} />
                ) : (
                  <img src={imgUrl + '/img/store/d_soon.png'} />
                )}
              </dd>
            </dl>
            <dl>
              {/*<dt>광주</dt>*/}
              <dd>
                {item.g_stock <= 0 ? (
                  <img src={imgUrl + '/img/store/g_no.png'} />
                ) : item.g_stock >= 10 ? (
                  <img src={imgUrl + '/img/store/g_full.png'} />
                ) : (
                  <img src={imgUrl + '/img/store/g_soon.png'} />
                )}
              </dd>
            </dl>
            <dl>
              {/*<dt>부산</dt>*/}
              <dd>
                {item.b_stock <= 0 ? (
                  <img src={imgUrl + '/img/store/b_no.png'} />
                ) : item.b_stock >= 10 ? (
                  <img src={imgUrl + '/img/store/b_full.png'} />
                ) : (
                  <img src={imgUrl + '/img/store/b_soon.png'} />
                )}
              </dd>
            </dl>
          </div>
          <img src={item.imageS} />{' '}
          {/* 실제 서비스시 originalImg 등록 후 변경할 것 */}
        </div>
      );
    });
    return list;
  };
  _afterChange = (index, idx) => {};
  _beforChange = (current, next) => {
    const { originalList } = this.state;
    //console.log(next)
    //console.log(originalList)
    if (originalList) {
      const ichSerial = originalList[next].ichSerial;
      this._getTop(ichSerial);
      this.setState({
        slideIndex: next,
      });
    } else {
      this.setState({
        slideIndex: next,
      });
    }
    //const { originalList } = this.state
    //console.log('aaaa ==> ' + current)
    //if(current > 0) {
    //    console.log(bannerList[current].idx)
    //}
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    // const { originalList } = this.state;
    ////console.log(i)
    //console.log(i)
    //const ichSerial = originalList[i].ichSerial
    //console.log(ichSerial)
    //this._getTop(ichSerial)
    if (this._isLoad) {
      this.slider.slickGoTo(i);
    }
  };
  _back = () => {
    const { history } = this.props;

    history.goBack();
  };
  _toggle = () => {
    const { toggle } = this.state;

    this.setState({
      toggle: !toggle,
    });
  };
  render() {
    const {
      originalList,

      con,
      ichSerial,
      topInfo,

      goodList,
      toggle,
    } = this.state;
    const { imgUrl } = this.props;
    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: originalList
        ? originalList.length < 12
          ? originalList.length
          : 12
        : 9,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      //speed: 3000,
      className: 'store_orgin_list',
      pauseOnFocus: true,
      //fade: true,
      adaptiveHeight: false,
      centerMode: false,

      //variableWidth: true,
      beforeChange: (current, next) => this._beforChange(current, next),
      afterChange: (index) => this._afterChange(index),
    };
    return (
      <Fragment>
        <div className="content">
          <StoreLeftMenu />

          {/* 오른쪽 콘텐츠 */}
          <div className="vod_list_right store_right">
            <div className="vod_list_group">
              <div className="store_wrap">
                {/* 스토어 스토리 */}
                <div className="store_blog orgin">
                  {/* 스토리 상단 */}
                  <div className="blog_top">
                    <h2 className="tit">
                      <button
                        type="button"
                        className="btn_prev"
                        onClick={this._back}
                      >
                        <img
                          src={imgUrl + '/img/store/arrw_pre.svg'}
                          alt="이전"
                        />
                      </button>
                      오리지널 굿즈
                    </h2>
                  </div>
                  {/* 스토리 본문 */}
                  <div className="blog_container">
                    {/* 오리지널 굿즈 */}
                    <div className="store_orgin">
                      {/* 오리지널 굿즈 상단 */}
                      <div className="store_orgin_top">
                        <h3>
                          <span className="tag">오리지널 굿즈</span>{' '}
                          <strong className="num">총 {con}개</strong>
                        </h3>
                        <ul className="store_orgin_rt">
                          <li>
                            오직 애니플러스에서만 만날 수 있는 애니플러스
                            오리지널 굿즈<em>!</em>
                            <br />
                            국내 최대 규모, 최고의 퀄리티, 애니플러스만이 가능한
                            노하우로 고객님이 만족하시는 최고의 굿즈를 만듭니다.
                          </li>
                          <li>
                            <img
                              src={imgUrl + '/img/store/aniplus_orgin.png'}
                              alt="ANIPLUS ORIGINAL GOODS"
                            />
                          </li>
                        </ul>
                      </div>
                      {/* 오리지널 굿즈 컨테이너 */}
                      <div
                        className="store_orgin_container"
                        onMouseEnter={this._toggle}
                        onMouseLeave={this._toggle}
                      >
                        {/* 슬라이드 이전/다음 */}
                        {toggle ? (
                          <>
                            <button
                              type="button"
                              className="orgin_arrw prev"
                              onClick={this._onPrev}
                            >
                              <img
                                src={imgUrl + '/img/store/arrw_slide_prev.svg'}
                                alt="이전"
                              />
                            </button>
                            <button
                              type="button"
                              className="orgin_arrw next"
                              onClick={this._onNext}
                            >
                              <img
                                src={imgUrl + '/img/store/arrw_slide_next.svg'}
                                alt="다음"
                              />
                            </button>
                          </>
                        ) : null}

                        {/* 오리지널 굿즈 리스트 */}
                        {/*<div className="store_orgin_list">*/}
                        <Slider
                          ref={(ref) => (this.slider = ref)}
                          {...settings}
                        >
                          {originalList ? this._renderItem() : null}
                        </Slider>
                        {/*</div>*/}
                      </div>
                    </div>
                    {/* 내용 */}
                    <div className="blog_content">
                      <div className="img_orgin">
                        {topInfo ? (
                          topInfo[0].image2 === '' ||
                          topInfo[0].image2 === undefined ||
                          topInfo[0].image2 === null ? (
                            <div className="img_orgin_visual">
                              <img src={topInfo ? topInfo[0].image1 : null} />
                              {/*실제 서비스시 image2에 등록후에 변경 할 것 */}
                            </div>
                          ) : (
                            <>
                              <div className="img_orgin_visual">
                                <img src={topInfo ? topInfo[0].image2 : null} />
                                {/*실제 서비스시 image2에 등록후에 변경 할 것 */}
                              </div>

                              <div className="img_orgin_list">
                                {goodList
                                  ? goodList.length > 0
                                    ? this._renderGoodItem()
                                    : null
                                  : null}
                              </div>
                            </>
                          )
                        ) : null}
                      </div>
                    </div>
                  </div>

                  {/* 댓글 */}
                  {ichSerial !== 0 ? <OriginalComment idx={ichSerial} /> : null}
                </div>

                {/* 오리지널 굿즈 온라인 판매 */}
                {ichSerial !== 0 ? (
                  <OriginalGoodsEtcList idx={ichSerial} />
                ) : null}
              </div>
            </div>
            <Footer />
          </div>
          {/* /220109 store */}
          <div className="clear"></div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(StoreOriginalGoods)));
